import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { Position } from 'src/app/core/types';

@Directive({
    selector: '[glContextMenu]',
    standalone: false
})
export class ContextMenuDirective implements OnInit {
  @Input() public mousePosition: Position;
  @Input() public boundaryWidth: number;
  @Input() public boundaryHeight: number;

  constructor(private elRef: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  public ngOnInit(): void {
    this.setAbsolutePosition();
    setTimeout(() => {
      this.setComponentPositionHorizontally();
      this.setComponentPositionVertically();
    });
  }

  private setAbsolutePosition() {
    this.renderer.setStyle(this.elRef.nativeElement, 'position', 'absolute');
  }

  private setComponentPositionHorizontally(): void {
    const elementDimensions = this.elRef.nativeElement.getBoundingClientRect();
    if (this.mousePosition.x + elementDimensions.width > this.boundaryWidth) {
      this.renderer.setStyle(
        this.elRef.nativeElement,
        'right',
        this.boundaryWidth - this.mousePosition.x + 'px',
      );
    } else {
      this.renderer.setStyle(this.elRef.nativeElement, 'left', this.mousePosition.x + 'px');
    }
  }

  private setComponentPositionVertically(): void {
    const elementDimensions: DOMRect = this.elRef.nativeElement.getBoundingClientRect();
    const windowHeight: number = window.innerHeight;
    const isBeyondWindowHeight: boolean =
      this.boundaryHeight - this.mousePosition.y + elementDimensions.height > 50;
    if (
      this.mousePosition.y + elementDimensions.height > this.boundaryHeight &&
      !isBeyondWindowHeight
    ) {
      this.renderer.setStyle(
        this.elRef.nativeElement,
        'bottom',
        this.boundaryHeight - this.mousePosition.y + 'px',
      );
    } else {
      const howMuchBeyond: number = this.mousePosition.y + elementDimensions.height - windowHeight;
      const offset: number = howMuchBeyond > 0 ? howMuchBeyond + 60 : 0;
      this.renderer.setStyle(this.elRef.nativeElement, 'top', this.mousePosition.y - offset + 'px');
    }
  }
}
